
/* injects from baggage-loader */

// AVATARS

import avatar1 from '_images/avatars/01.png';
import avatar2 from '_images/avatars/02.png';
import avatar3 from '_images/avatars/03.png';
import avatar4 from '_images/avatars/04.png';
import avatar5 from '_images/avatars/05.png';
import avatar6 from '_images/avatars/06.png';

import avatar1_full from '_images/avatars/01-full.png';
import avatar2_full from '_images/avatars/02-full.png';
import avatar3_full from '_images/avatars/03-full.png';
import avatar4_full from '_images/avatars/04-full.png';
import avatar5_full from '_images/avatars/05-full.png';
import avatar6_full from '_images/avatars/06-full.png';

import active_avatar1 from '_images/avatars/01_active.png';
import active_avatar2 from '_images/avatars/02_active.png';
import active_avatar3 from '_images/avatars/03_active.png';
import active_avatar4 from '_images/avatars/04_active.png';
import active_avatar5 from '_images/avatars/05_active.png';
import active_avatar6 from '_images/avatars/06_active.png';

import balloon_avatar1 from '_images/avatars/01-balloon.png';
import balloon_avatar2 from '_images/avatars/02-balloon.png';
import balloon_avatar3 from '_images/avatars/03-balloon.png';
import balloon_avatar4 from '_images/avatars/04-balloon.png';
import balloon_avatar5 from '_images/avatars/05-balloon.png';
import balloon_avatar6 from '_images/avatars/06-balloon.png';


export const avatars = [
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6
]

export const avatars_full = [
  avatar1_full,
  avatar2_full,
  avatar3_full,
  avatar4_full,
  avatar5_full,
  avatar6_full
]

export const avatars_active_status = [
  active_avatar1,
  active_avatar2,
  active_avatar3,
  active_avatar4,
  active_avatar5,
  active_avatar6
]

export const avatars_balloons = [
  balloon_avatar1,
  balloon_avatar2,
  balloon_avatar3,
  balloon_avatar4,
  balloon_avatar5,
  balloon_avatar6
]


// Numerals
export const NumeralsI18n = {
  female: {    
    1: 'uma',
    2: 'duas',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  },
  male: {
    1: 'um',
    2: 'dois',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  }  
}

// Playmode

export const PlayerClass = {
  client: 1,
  garcom: 2,
  chef: 3
}


// Trophies

export const trophies = {
  default: [
    require('_images/trophies/01.png'),
    require('_images/trophies/02.png'),
    require('_images/trophies/03.png'),
    require('_images/trophies/04.png'),
    require('_images/trophies/05.png')
  ],
  chef: [
    require('_images/trophies/chef_01.png'),
    require('_images/trophies/chef_02.png'),
    require('_images/trophies/chef_03.png'),
    require('_images/trophies/chef_04.png'),
    require('_images/trophies/chef_05.png')
  ]
}


// WEBPACK FOOTER //
// ./src/app/index.const.js